/**
 * LifeHeader
 * 詳細設計書 §4.1 ヘッダー UI 要素に対応。
 */
function LifeHeader({ onBack }) {
  return (
    <header className="life-header">
      <button className="life-header__back" onClick={onBack} aria-label="戻る">
        ← 戻る
      </button>
      <span className="life-header__title">Life</span>
      <span className="life-header__spacer" aria-hidden="true" />
    </header>
  );
}

export default LifeHeader;
